export default __webpack_public_path__ + "static/media/doesit.fbbf22c5.png";